export default "__VITE_ASSET__50f1d945__"